module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-flex",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "o-container u-flex u-flex-width"
  }, [_c('div', {
    staticClass: "o-layout o-layout--spacing-large u-flex"
  }, [_c('div', {
    staticClass: "o-box o-box--spacing-regular o-layout__item u-10/12 u-offset-1/12 u-background-white u-flex"
  }, [_c('transition', {
    attrs: {
      "name": "change",
      "enter-active-class": "anim-enter",
      "leave-active-class": "anim-out",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe2ae36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 140
// module chunks = 1